"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.localStorageData = localStorageData;
var _react = require("react");
const useLocalStorageSync = (stateData, setStateData, settings, pageFocussed) => {
  const {
    crossStorageUrl,
    storageKey
  } = settings; // (1) state -> localStorage

  (0, _react.useEffect)(() => {
    if (crossStorageUrl) return;
    setLocalStorageData(stateData, storageKey);
  }, [stateData, storageKey, crossStorageUrl]); // (2) localStorage -> state

  (0, _react.useEffect)(() => {
    if (crossStorageUrl) return;
    if (!pageFocussed) return;
    const storageListener = ev => {
      if (ev.key === storageKey) {
        setStateData(localStorageData(storageKey));
      }
    };
    window.addEventListener("storage", storageListener);
    return () => window.removeEventListener("storage", storageListener);
  }, [storageKey, setStateData, crossStorageUrl, pageFocussed]);
};
var _default = useLocalStorageSync;
exports.default = _default;
function localStorageData(storageKey) {
  if (typeof window === "undefined") return;
  return JSON.parse(window.localStorage.getItem(storageKey));
}
function setLocalStorageData() {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let storageKey = arguments.length > 1 ? arguments[1] : undefined;
  window.localStorage.setItem(storageKey, JSON.stringify(data));
}